import { clsx } from 'clsx';
import { X } from 'lucide-react';

type ToastVariant = 'success' | 'error' | 'info' | 'warning';

const VARIANT: Record<ToastVariant, string> = {
  success: 'bg-green-ok text-white',
  error: 'bg-rose text-white',
  info: 'bg-sage-dk text-white',
  warning: 'bg-gold text-white',
};

export function Toast({
  variant,
  message,
  onDismiss,
}: {
  variant: ToastVariant;
  message: string;
  onDismiss: () => void;
}) {
  return (
    <div
      className={clsx('flex items-center gap-3 rounded-xl px-4 py-3 shadow-lg', VARIANT[variant])}
      role="status"
    >
      <span className="flex-1">{message}</span>
      <button aria-label="dismiss" onClick={onDismiss} className="opacity-80 hover:opacity-100">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
